"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
// biome-ignore lint/style/noRestrictedImports: This is our wrapper around Next.js Link
import NextLink from "next/link";
import type { HTMLProps, ReactNode, Ref } from "react";
import { type LinkVariant, type OpenInNewTab, getLinkTarget } from "./link.utilities";
export type RegularLinkProps = HTMLProps<HTMLAnchorElement> & {
  readonly ariaLabel?: string;
  readonly className?: string;
  readonly children: ReactNode;
  readonly href: string;
  readonly tabIndex?: number;
  readonly openInNewTab?: OpenInNewTab;
  readonly testId?: string;
  readonly scroll?: boolean;
  readonly position?: string;
  readonly variant?: LinkVariant;
  readonly ref?: Ref<HTMLAnchorElement>;
  readonly id?: string | number;
  readonly role?: string;
};
export function RegularLink(t0) {
  const $ = _c(26);
  const {
    ariaLabel,
    children,
    className,
    href,
    onKeyDown,
    onMouseDown,
    onClick,
    openInNewTab: t1,
    position,
    scroll: t2,
    tabIndex: t3,
    testId,
    variant: t4,
    ref,
    id,
    role
  } = t0;
  const openInNewTab = t1 === undefined ? false : t1;
  const scroll = t2 === undefined ? true : t2;
  const tabIndex = t3 === undefined ? 0 : t3;
  const variant = t4 === undefined ? null : t4;
  let t5;
  if ($[0] !== href || $[1] !== openInNewTab) {
    t5 = getLinkTarget(href, openInNewTab);
    $[0] = href;
    $[1] = openInNewTab;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const target = t5;
  const t6 = variant === "primary" && "text-primary hover:text-primary-hover hover:underline";
  const t7 = variant === "secondary" && "text-secondary underline hover:no-underline";
  const t8 = variant === "accent" && "text-secondary underline hover:no-underline";
  const t9 = variant === "inherit" && "text-inherit underline hover:text-black";
  const t10 = variant === "inverse" && "footer-link";
  let t11;
  if ($[3] !== className || $[4] !== t10 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
    t11 = clsx("wrap-break-word hyphens-manual transition-all", t6, t7, t8, t9, t10, className);
    $[3] = className;
    $[4] = t10;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const t12 = `${href}`;
  let t13;
  if ($[10] !== ariaLabel || $[11] !== children || $[12] !== id || $[13] !== onClick || $[14] !== onKeyDown || $[15] !== onMouseDown || $[16] !== position || $[17] !== ref || $[18] !== role || $[19] !== scroll || $[20] !== t11 || $[21] !== t12 || $[22] !== tabIndex || $[23] !== target || $[24] !== testId) {
    t13 = <NextLink aria-label={ariaLabel} className={t11} data-k5a-pos={position} data-testid={testId} href={t12} key={id} onClick={onClick} onKeyDown={onKeyDown} onMouseDown={onMouseDown} prefetch={false} ref={ref} role={role} scroll={scroll} tabIndex={tabIndex} target={target}>{children}</NextLink>;
    $[10] = ariaLabel;
    $[11] = children;
    $[12] = id;
    $[13] = onClick;
    $[14] = onKeyDown;
    $[15] = onMouseDown;
    $[16] = position;
    $[17] = ref;
    $[18] = role;
    $[19] = scroll;
    $[20] = t11;
    $[21] = t12;
    $[22] = tabIndex;
    $[23] = target;
    $[24] = testId;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}